export const parseNAICS = (code?: string, name?: string) => {
  if (!code && !name) return null;
  if (!code) return name;
  if (!name) return code;
  return `${code} - ${name}`;
};
